
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    }
  },
  computed: {
    disable_tooltip() {
      return !this.$responsive.desktop
    }
  }
}
